import { Outlet } from 'react-router-dom';
import { Demo2Layout } from '@/layouts/demo2/layout';

export default function Layout() {
  return <Demo2Layout />;
}
